import { defineMessages } from 'react-intl';

export default defineMessages({
  autoBatchingHeader: {
    description: 'Orders > Other Actions > Auto Create Batches Header',
    defaultMessage: 'Auto Create Batches from <b>{totalRecords}</b> Selected Orders',
    id: 'vYiT5J',
  },
  autoBatchingSubmissionAction: {
    description: 'Orders > Other Actions > Auto Create Batches (controls the button)',
    defaultMessage: 'Auto Create Batches',
    id: '5L43RA',
  },
  autoBatchingNotesForBatch: {
    description: 'Orders > Other Actions > Auto Create Batches - Batch Notes',
    defaultMessage: 'Batch Notes',
    id: '5CIStp',
  },
  autoBatchingCancel: {
    description: 'Orders > Other Actions > Auto Create Batches - Cancel (button)',
    defaultMessage: 'Cancel',
    id: 'STvtsR',
  },
  autoBatchingClose: {
    description: 'Orders > Other Actions > Auto Create Batches - Close (button)',
    defaultMessage: 'Close',
    id: '4Uj6ck',
  },
  autoBatchingErrorMessage: {
    description: 'Orders > Other Actions > Auto Create Batches - Error Display',
    defaultMessage: 'An error occurred, please try again.',
    id: '+/szqC',
  },
  autoBatchingTotalExceeded: {
    description: 'Orders > Other Actions > Auto Create Batches - Total allowed records exceeded',
    defaultMessage:
      '<b>You have exceeded the {totalAllowed} order maximum allowed for auto-batching.</b> Please select {totalAllowed} or fewer orders and try again.',
    id: 'EpCFnd',
  },
  autoBatchingResponseBatchCount: {
    description: 'Orders > Other Actions > Auto Create Batches - Successfully created Total number of batches',
    defaultMessage: 'Batches Created',
    id: '5fCGtI',
  },
  autoBatchingResponseTotalOrdersCount: {
    description: 'Orders > Other Actions > Auto Create Batches - Successfully created Total number of batches',
    defaultMessage: 'Total Orders',
    id: 'w/MjJM',
  },
  autoBatchingHeaderSucceeded: {
    description: 'Orders > Other Actions > Auto Create Batches - Successfully Created Batches',
    defaultMessage: 'Successfully Created Batches for <b>{totalRecords}</b> Orders',
    id: 'DE4Dws',
  },
  autoBatchingViewBatches: {
    description: 'Orders > Other Actions > Auto Create Batches - View Batches',
    defaultMessage: 'View Batches',
    id: 'ok5M12',
  },
  autoBatchingOrdersIncludedInAnotherBatch: {
    description: 'Orders > Other Actions > Auto Create Batches - Orders in another Batch warning',
    defaultMessage:
      '{totalAlreadyBatched} of the selected orders are already in a batch. Click <b>Confirm</b> if you wish to move them to the new batch.',
    id: 'QkibuW',
  },
  confirmMoveButton: {
    description: 'Orders > Other Actions > Auto Create Batches - Confirm button',
    defaultMessage: 'Confirm',
    id: 'ywNk9/',
  },
  removeFromSelectedOrders: {
    description: 'Orders > Other Actions > Auto Create Batches - Remove from Selected Orders',
    defaultMessage: 'Remove from Selected Orders',
    id: 's0xF/Y',
  },
  autoBatchingTotalNumberOfOrders: {
    description: 'Orders > Other Actions > Auto Create Batches - Orders Selected',
    defaultMessage: 'Orders Selected',
    id: 'Cb1hb/',
  },
  suggestedBatchByOrderCountLabel: {
    description: 'Orders > Other Actions > Auto Create Batches - Helper text describing number of batches',
    defaultMessage: 'in <b>{anticipatedCount}</b> total batches',
    id: 'vrYyD/',
  },
  suggestedBatchByBatchCountLabel: {
    description: 'Orders > Other Actions > Auto Create Batches - Helper text describing number of batches',
    defaultMessage: 'with <b>{anticipatedCount}</b> orders in each batch',
    id: '/MTFp4',
  },
  autoBatchingResponseTooltip: {
    description: 'Orders Grid > Other Actions > Auto Create Batches - number of Orders per Batch tooltip',
    defaultMessage: 'Your orders will be distributed as evenly as possible.',
    id: 'BqtDq1',
  },
  autoBatchResponseSingleCount: {
    description: 'Orders Grid > Other Actions > Auto Create Batches - Response message single count',
    defaultMessage: '<b>{batchCount}</b> Batches of <b>{orderCount}</b> = <b>{totalRecords}</b> Orders.',
    id: 'zFi0dD',
  },
  autoBatchResponseMultiCount: {
    description: 'Orders Grid > Other Actions > Auto Create Batches - Response message single count',
    defaultMessage:
      '<b>{batchCount}</b> Batches of <b>{orderCount}</b> and <b>1</b> Batch of <b>{trailingBatchOrderCount}</b> = <b>{totalRecords}</b> Orders.',
    id: 'zNEy1t',
  },
  autoBatchingResponseTotalBatchesHeader: {
    description: 'Orders Grid > Other Actions > Auto Create Batches - Total Batches',
    defaultMessage: 'Total Batches',
    id: '/bac91',
  },
  autoBatchingResponseTotalOrdersHeader: {
    description: 'Orders > Other Actions > Auto Create Batches - Total Orders',
    defaultMessage: 'Total Orders',
    id: 'UQzomi',
  },
  autoBatchingResponseBatchHeader: {
    description: 'Orders Grid > Other Actions > Auto Create Batches - Response display Batch column',
    defaultMessage: 'Batch',
    id: 'iovpMU',
  },
  autoBatchingResponseOrdersPerBatchHeader: {
    description: 'Orders > Other Actions > Auto Create Batches - Orders per Batch',
    defaultMessage: 'Orders per Batch',
    id: 'eCdq1E',
  },
});
